$(document).ready(function(){

    $(".cattitle").click(function(){
      $(".searchtitle").removeClass("on");
      $(".searchholder").removeClass("on");
      $(".allcats").toggleClass("on");
      $(".cattitle").toggleClass("on");
    });
  
  $(".searchtitle").click(function(){
      $(".cattitle").removeClass("on");
      $(".allcats").removeClass("on");
      $(".searchholder").toggleClass("on");
      $(".searchtitle").toggleClass("on");
    });
  
  });